<template>
     <v-content>
      <v-btn
        @click.stop="mapdrawer = !mapdrawer"
        color="black"
        small
        dark
        fab
        fixed
        top
        right>
        <v-icon>menu</v-icon>
      </v-btn>
      <v-container fluid fill-height class="pa-0">
        <v-layout
          justify-center
          align-center>
          <v-flex text-xs-center>

           <v-navigation-drawer
                :mobile-break-point="breakPoint"
                v-model="mapdrawer"
                fixed
                right
                clipped
                app>
             <v-toolbar color="secondary" dense dark>
                 Open Houses
              </v-toolbar>
                <v-select
                    v-model="city"
                    :items="citiesSelection"
                    box
                    chips
                    color="blue-grey lighten-2"
                    label="Filter by city"
                    item-text="name"
                    item-value="value"
                    :clearable="true"
                    small-chips
                    :multiple="false">
                    <template v-slot:selection="data">
                      <v-chip
                        :selected="data.selected"
                        class="chip--select-multi">
                        <v-avatar dark class="white darken-4">
                          {{ data.item.count }}
                        </v-avatar>
                        {{ data.item.value }}
                      </v-chip>
                    </template>
                  
                </v-select>
                <v-list three-line dense>
                    <template v-for="(property, index) in filteredProperties">
                      <v-divider
                        :key="'divider-' + index"
                        :inset="true">
                      </v-divider>

                      <v-list-tile
                        :class="{ not_approved: !property.approved }"
                        :key="'image-' + index"
                        avatar
                        @click="displayProperty(property.id)">
                        <v-list-tile-avatar>
                          <img v-if="property.image" :src="property.image" @error="imageError(property)"/>
                          <img v-else-if="property.bedrooms === 0" :src="require('../assets/no-pic-commercial.png')" />
                          <img v-else :src="require('../assets/no-pic.png')" />
                        </v-list-tile-avatar>

                        <v-list-tile-content>
                          <v-list-tile-title :class="{ not_approved: property.lat === 0 }" v-html="property.address"></v-list-tile-title>
                          <v-list-tile-sub-title v-if="property.bedrooms === 0">Commercial Property <br /> <strong>{{ getMoney(property.price) }}</strong></v-list-tile-sub-title>
                          <v-list-tile-sub-title v-else>{{ getBedsBaths(property.bedrooms) }} beds, {{ getBedsBaths(property.baths) }} baths <br /> <strong>{{ getMoney(property.price) }}</strong></v-list-tile-sub-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </template>
                  </v-list>
            </v-navigation-drawer>

            <GmapMap
                v-if="properties.length > 0"
                :center="mapCenter"
                :zoom="11"
                :class="[isAdmin ? 'admin_map' : 'full_map']">
                <template v-for="(property, index) in filteredProperties">
                  <GmapMarker
                      :key="index"
                      :icon="require('../assets/house-marker.png')"
                      :position="{lat: property.lat, lng: property.long}"
                      @click="currentInfoWindow = property.id">
                        <gmap-info-window
                        :options="infoOptions"
                        :position="{lat: property.lat, lng: property.long}"
                        :opened="currentInfoWindow === property.id"
                        @closeclick="currentInfoWindow = 'x'">
                        <v-card max-width="400" flat>
                          <v-img
                            v-if="property.image"
                            :src="property.image"
                            @error="imageError(property)"
                            aspect-ratio="2.75"></v-img>
                          <v-card-title primary-title class="pt-1 pb-1">
                            <div>
                              <h3 class="mb-0">{{ property.address }}</h3>
                              <h4 v-html="getDates(property.address)"></h4>
                              <div v-if="property.bedrooms === 0">Commercial Property ~ <strong>{{ getMoney(property.price) }}</strong> </div>
                              <div v-else> {{ getBedsBaths(property.bedrooms) }} beds, {{ getBedsBaths(property.baths) }} baths ~ <strong>{{ getMoney(property.price) }}</strong> </div>
                              <div>
                                <a class="mt-1" v-if="property.realtorurl" :href="property.realtorurl" target="_blank">{{ property.realtor }}</a>
                                <span v-else>{{ property.realtor }}</span>
                              </div>
                              <div class="mt-1" v-if="property.host">
                                {{ property.host }}<span v-if="property.hostphone">  <br /> {{ formatPhoneNumber(property.hostphone) }}</span>
                              </div>
                            </div>
                          </v-card-title>
                          <v-card-text class="text-xs-left pt-1">
                            
                          </v-card-text>
                          <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-tooltip v-if="property.description" top>
                            <v-btn slot="activator" flat color="secondary" icon @click="showDescription(property)">
                              <v-icon>notes</v-icon>
                            </v-btn>
                            <span> Description </span>
                          </v-tooltip>
                          <v-tooltip v-if="property.houseurl" top>
                            <v-btn 
                              slot="activator"
                              flat color="secondary" icon 
                              :href="property.houseurl"
                              target="_blank">
                             <v-icon>find_in_page</v-icon>
                            </v-btn>
                            <span>Property Details</span>
                          </v-tooltip>
                           <v-tooltip v-if="property.email" top>
                            <v-btn 
                              slot="activator"
                              flat color="secondary" icon 
                              :href="'mailto:' + property.email"
                              target="_blank">
                             <v-icon>email</v-icon>
                            </v-btn>
                            <span>Email</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <v-btn slot="activator" flat color="secondary" icon @click="print(property)">
                             <v-icon>print</v-icon>
                            </v-btn>
                            <span>Print</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <v-btn slot="activator" flat color="secondary" icon target="_blank" :href="navigate(property)">
                              <v-icon>drive_eta</v-icon>
                            </v-btn>
                            <span>Navigate</span>
                          </v-tooltip>
                          <v-tooltip v-if="isAdmin"  top>
                            <v-btn slot="activator" v-if="isAdmin" flat color="secondary"  :to="{path: 'edit/' + property.id}" icon><v-icon>edit</v-icon></v-btn>
                            <span>Edit</span>
                          </v-tooltip>
                          </v-card-actions>
                        </v-card>
                      </gmap-info-window>
                  </GmapMarker>
                </template>
              </GmapMap>
              <span v-else>Sorry, no properties are entered at this time. Try again later.</span>
          </v-flex>
        </v-layout>
      </v-container>
      <v-dialog
        v-model="descriptionDialog"
        width="500">
        <v-card>
          <v-card-title
            class="headline grey lighten-2"
            primary-title>
            {{ showProperty.address }}
          </v-card-title>

          <v-card-text>
            {{ showProperty.description }}
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              flat
              @click="descriptionDialog = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-content>
</template>
<script>
   export default {
    name: 'Map',
    mounted: function() {

    },
    data: () => ({
     infoOptions: {
          pixelOffset: {
            width: 0,
            height: 0
          }
      },
      currentInfoWindow: 'x',
      descriptionDialog: false,
      showProperty: {},
      city: '',
      breakPoint: 900,
    }),

    props: {

    },

    computed: {
      citiesSelection() {
        let newCites = [];
        this.cities.forEach(city => {
          let properties = this.cleanUp(JSON.parse(JSON.stringify(this.properties)));

          properties = properties.filter(property => {
           if (property.address.toLowerCase().includes(city.toLowerCase())) {
             return property;
           }
          });
          
          if (properties.length > 0) {
            newCites.push({name: city + ' (' + properties.length + ')', value: city, count: properties.length});
          }
        })
        return newCites;
      },
      filteredProperties() {
        let filteredProperties = this.cleanUp(JSON.parse(JSON.stringify(this.properties)));
        let city = this.city;
        if (city) {
          filteredProperties = filteredProperties.filter(property => {
            if (property.address.toLowerCase().includes(city.toLowerCase())) {
               return property;
            }
          });
        }
        return filteredProperties;
      },
      mapCenter() {
        let mapCenter = {lat: 47.6015219, lng: -117.3745635}
        let coords = [];
        this.filteredProperties.forEach(property => {
          coords.push({lat: property.lat, lng: property.long});
        });
        if (coords.length === 0) {
          return mapCenter;
        }
        if (coords.length === 1) {
          return coords[0];
        }


        let x = 0.0;
        let y = 0.0;
        let z = 0.0;

        for (let coord of coords) {
          let latitude = coord.lat * Math.PI / 180;
          let longitude = coord.lng * Math.PI / 180;

          x += Math.cos(latitude) * Math.cos(longitude);
          y += Math.cos(latitude) * Math.sin(longitude);
          z += Math.sin(latitude);
        }

        let total = coords.length;

        x = x / total;
        y = y / total;
        z = z / total;

        let centralLongitude = Math.atan2(y, x);
        let centralSquareRoot = Math.sqrt(x * x + y * y);
        let centralLatitude = Math.atan2(z, centralSquareRoot);

        mapCenter = {lat: centralLatitude * 180 / Math.PI, lng: centralLongitude * 180 / Math.PI}

        return mapCenter;
    },
     mapdrawer: {
        get() {
          return this.$store.state.mapdrawer;
        },
        set(value) {
          this.$store.commit("set_mapdrawer", value);
        }
      },
      properties: {
        get() {
          return this.$store.state.properties;
        },
        set(value) {
          this.$store.commit("set_properties", value);
        }
      },
      isAdmin: {
        get() {
          return this.$store.state.isAdmin;
        },
        set(value) {
          this.$store.commit("set_isAdmin", value);
        }
      },
      
      siteTitle: {
        get() {
          return this.$store.state.siteTitle;
        },
        set(value) {
          this.$store.commit("set_siteTitle", value);
        }
      },
      siteName: {
        get() {
          return this.$store.state.siteName;
        },
        set(value) {
          this.$store.commit("set_siteName", value);
        }
      },
      cities: {
        get() {
          return this.$store.state.cities;
        },
        set(value) {
          this.$store.commit("set_cities", value);
        }
      },
    },

    methods: {
      cleanUp(properties) {
        if (!this.isAdmin) {
          properties.forEach((property, index) => {
            if (property.lat === 0 && property.long === 0) {
                properties.splice(index, 1);
            }
          });
          properties.forEach((property, index) => {
            let dups = properties.filter(p => {
                if (p.address.toLowerCase() === property.address.toLowerCase()) {
                  return p;
                }
            });
            if (dups.length > 1) {
              properties.splice(index, 1);
            }
          });
        }
        return properties;
      },
      getDates(address) {
        let properties = this.properties.filter(property => {
          if (property.address.toLowerCase() === address.toLowerCase()) {
            return property;
          }
        });
        let justDates = [];
        properties.forEach(property => {
          let dateTime = this.$moment(property.date).format("dddd, MMMM Do YYYY") + ' ~ ' + property.starttime + ' to ' + property.endtime;
          if (!justDates.includes(dateTime)) {
            justDates.push(dateTime);
          }
        });
        return justDates.join('<br />');
      },

      imageError(property) {
          property.image = '';
          let propertyIndex = this.properties.findIndex(p => p.id === property.id);
          this.properties[propertyIndex] = property;
          this.properties = this.properties;
      },
      displayProperty(property) {
        this.currentInfoWindow = property;
        if (window.innerWidth <= this.breakPoint) {
          this.mapdrawer = false;
        }
      },
      navigate(property) {
          return 'https://maps.google.com/maps?q=' + property.lat + ',+' + property.long + '+(' + property.address + ')&amp;iwloc=A&amp;hl=en';
      },
      print(property) {
          window.open('print.php?id='+ property.id,'printwindow','width=960,height=600');
      },
      showDescription(property) {
        this.descriptionDialog = true;
        this.showProperty = property;
      },
      getMoney(price) {
         return '$' + price.toLocaleString('en');
      },
      getBedsBaths(num) {
        return (num * 1);
      },
      formatPhoneNumber(phoneNumberString) {
          if (phoneNumberString) {

            if (phoneNumberString) {
              if (phoneNumberString.length == 11 && phoneNumberString.substring(0, 1) == 1) {
                phoneNumberString = phoneNumberString.substring(1, 11);
              }
              let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
              let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
              if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3]
              }
            }
          }
          return phoneNumberString
       },
    }
   }
</script>
<style>
   .not_approved {
     background-color: #ffcccc;
   }
   .full_map {
      width: 100%; 
      height: calc(100vh - 32px);
   }
   .admin_map {
      width: 100%; 
      height: calc(100vh - 80px);
   }
</style>